import { render, staticRenderFns } from "./TrafficViloationEdit.vue?vue&type=template&id=d8977666"
import script from "./TrafficViloationEdit.vue?vue&type=script&lang=js"
export * from "./TrafficViloationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports